import React from "react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

/**
 * Shared layout for legal + long-form content pages.
 * Uses the same marketing navbar/footer so navigation is consistent
 * across the whole site.
 */
export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-lm-bg text-lm-text flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-5 md:px-10 py-14 md:py-20">
        <div className="mb-10">
          <div className="text-[11px] font-mono uppercase tracking-widest text-lm-secondary">
            Legal
          </div>
          <h1 className="mt-2 text-3xl md:text-5xl font-display font-semibold tracking-tight leading-tight">
            {title}
          </h1>
          {updated && (
            <p className="mt-3 text-sm text-lm-text3 font-mono">Last updated: {updated}</p>
          )}
        </div>

        <article className="prose prose-lm max-w-none text-lm-text leading-relaxed">
          {children}
        </article>
      </main>
      <Footer />
    </div>
  );
}
